export default [
  {
    name: 'portalsMenu',
    url: '/portals',
    access: 'ADMIN RBU DEALER CEC ECOM',
    icon: 'fa fa-building-o',
  },
  {
    name: 'membersMenu',
    url: '/members',
    access: 'ADMIN ADMIN_RBU ADMIN_DEALER',
    icon: 'fa fa-building-o',
  },
]
